module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Left-circle-b11e7a6950e6e3a2c91de66873484515.svg";